export default __webpack_public_path__ + "static/media/colorful_paragraph.27b34bbe.svg";